const classNames = (...classes: (string | null | false | undefined)[]): string => classes.filter(Boolean).join(' ');
export default classNames;
